export const siteInfo = {
  name: '向日葵视频',
  tagline: '数字视频平台大全',
  slogan: '汇集全网数字视频，畅享高清流畅观看体验',
};

export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '专题合集', href: '#index' },
  { label: '视频精选', href: '#media' },
  { label: '平台优势', href: '#features' },
  { label: '焦点专题', href: '#carousel' },
];

export const aboutData = {
  title: '关于向日葵视频',
  description: '向日葵视频是一个专注于数字视频平台内容聚合与推荐的综合性导航站点。我们深度覆盖91视频、97视频、51视频、久久视频等主流数字视频平台，致力于为广大用户提供高清、流畅、便捷的在线观看入口。',
  highlights: [
    { label: '覆盖平台', value: '50+' },
    { label: '每日更新', value: '2000+' },
    { label: '在线用户', value: '100万+' },
  ],
};

export const topicsData = {
  title: '热门话题',
  items: [
    { name: '91视频', heat: '9.8万', trending: true },
    { name: '97视频', heat: '8.6万', trending: true },
    { name: '51视频', heat: '7.3万', trending: false },
    { name: '久久视频', heat: '6.9万', trending: true },
    { name: '高清专区', heat: '6.2万', trending: false },
    { name: '最新上架', heat: '5.5万', trending: true },
    { name: '热门推荐', heat: '5.1万', trending: false },
    { name: '经典回顾', heat: '4.8万', trending: false },
    { name: '新片速递', heat: '4.3万', trending: true },
    { name: '独家内容', heat: '4.0万', trending: false },
  ],
};

export const featuresData = {
  title: '平台优势',
  items: [
    {
      icon: 'ri-shield-check-line',
      title: '安全稳定',
      desc: '多重加密传输，保障用户观看隐私与数据安全，畅享无忧体验。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '极速加载',
      desc: '全球CDN加速节点覆盖，视频秒开不卡顿，高清画质流畅播放。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端适配',
      desc: 'PC端、移动端、平板全设备兼容，随时随地想看就看。',
    },
    {
      icon: 'ri-stack-line',
      title: '海量资源',
      desc: '聚合91视频、97视频、51视频、久久视频等平台，内容持续更新。',
    },
  ],
};

export const updatesData = {
  title: '最新动态',
  items: [
    {
      date: '2026-07-30',
      content: '向日葵视频平台新增51视频高清专区入口，内容覆盖更全面。',
      tag: '平台更新',
    },
    {
      date: '2026-07-28',
      content: '久久视频热门内容专题页面上线，精选高分资源一站式浏览。',
      tag: '专题上线',
    },
    {
      date: '2026-07-25',
      content: '移动端观看体验全面优化，加载速度提升40%，流量消耗降低25%。',
      tag: '体验优化',
    },
    {
      date: '2026-07-22',
      content: '91视频同类型数字视频平台新增5家合作站点，资源库再扩容。',
      tag: '资源扩充',
    },
    {
      date: '2026-07-20',
      content: '全站搜索功能升级，支持多平台跨站检索，精准定位想看的内容。',
      tag: '功能升级',
    },
    {
      date: '2026-07-18',
      content: '97视频高清全集频道改版完成，界面更清爽，分类更细致。',
      tag: '频道改版',
    },
    {
      date: '2026-07-15',
      content: '新增"数字视频在线"快捷收藏功能，喜欢的资源一键保存。',
      tag: '新功能',
    },
    {
      date: '2026-07-12',
      content: '向日葵视频用户社区开放内测，影迷交流互动更便捷。',
      tag: '社区上线',
    },
    {
      date: '2026-07-10',
      content: '平台安全系统全面升级，通过ISO 27001信息安全管理认证。',
      tag: '安全认证',
    },
  ],
};

export const indexData = {
  title: '专题合集',
  items: [
    {
      title: '91视频精选',
      desc: '精选91视频平台高分内容，每日更新推荐',
      tag: '热门',
    },
    {
      title: '97视频全集',
      desc: '97视频高清全集一站式导航，分类清晰',
      tag: '全集',
    },
    {
      title: '51视频专区',
      desc: '51视频独家内容聚合，发现更多精彩资源',
      tag: '独家',
    },
    {
      title: '久久视频推荐',
      desc: '久久视频优质内容整理，轻松找到心仪作品',
      tag: '推荐',
    },
    {
      title: '高清免费专区',
      desc: '汇集各平台免费高清资源，无需付费即可观看',
      tag: '免费',
    },
    {
      title: '新片速递',
      desc: '第一时间掌握各数字视频平台最新上架内容',
      tag: '新片',
    },
    {
      title: '经典老片回顾',
      desc: '不容错过的经典数字视频，重温往日精彩',
      tag: '经典',
    },
    {
      title: '同类型推荐',
      desc: '基于观看偏好智能推荐91视频同类型优质内容',
      tag: '智能',
    },
  ],
};

export const carouselData = {
  title: '焦点专题',
  items: [
    {
      title: '91视频热门榜单',
      desc: '实时更新的91视频热度排行榜，掌握当下最受欢迎的内容风向。',
      imageSeq: 'carousel-01',
      imageQuery: 'Warm%20golden%20abstract%20geometric%20composition%20with%20flowing%20organic%20shapes%2C%20modern%20digital%20art%20style%2C%20soft%20gradients%20from%20amber%20to%20cream%2C%20minimalist%20clean%20aesthetic%2C%20luxurious%20smooth%20textures%2C%20cinematic%20atmospheric%20lighting',
    },
    {
      title: '97视频高清合集',
      desc: '97视频全系列高清资源导航，分类详尽，快速定位你想看的内容类型。',
      imageSeq: 'carousel-02',
      imageQuery: 'Elegant%20abstract%20wave%20patterns%20in%20warm%20coral%20and%20cream%20tones%2C%20smooth%20flowing%20curves%2C%20modern%20minimalist%20design%2C%20soft%20ethereal%20lighting%2C%20premium%20textured%20finish%2C%20harmonious%20warm%20color%20palette',
    },
    {
      title: '51视频独家资源',
      desc: '51视频平台独家内容专题，发现那些只在特定平台才能看到的精彩资源。',
      imageSeq: 'carousel-03',
      imageQuery: 'Sophisticated%20abstract%20layered%20circles%20with%20golden%20honey%20and%20warm%20beige%20hues%2C%20modern%20art%20deco%20inspired%2C%20smooth%20gradients%2C%20luxurious%20feel%2C%20soft%20diffused%20lighting%2C%20premium%20aesthetic%20composition',
    },
    {
      title: '久久视频精选集',
      desc: '精心筛选久久视频平台中的优质内容，帮你在海量资源中快速找到好片。',
      imageSeq: 'carousel-04',
      imageQuery: 'Warm%20abstract%20fluid%20art%20with%20amber%20terracotta%20and%20cream%20swirls%2C%20organic%20flowing%20shapes%2C%20modern%20gallery%20style%2C%20soft%20atmospheric%20glow%2C%20minimalist%20luxurious%20composition%2C%20rich%20textural%20details',
    },
    {
      title: '数字视频平台大全',
      desc: '全方位数字视频平台导航指南，一站覆盖91、97、51、久久等主流视频站点。',
      imageSeq: 'carousel-05',
      imageQuery: 'Contemporary%20abstract%20mosaic%20with%20warm%20golden%20and%20terracotta%20tiles%2C%20geometric%20patterns%20intersecting%2C%20modern%20luxury%20design%2C%20soft%20ambient%20warm%20lighting%2C%20premium%20textured%20surface%2C%20harmonious%20elegant%20composition',
    },
  ],
};

export const faqData = {
  title: '常见问题',
  items: [
    {
      question: '向日葵视频是否需要注册才能观看？',
      answer: '向日葵视频作为数字视频平台导航站点，本身不需要注册即可浏览和访问所有收录平台。部分目标平台可能根据自身政策要求注册，具体以各平台规则为准。',
    },
    {
      question: '91视频、97视频等平台的更新频率如何？',
      answer: '向日葵视频实时同步各数字视频平台的更新动态，91视频、97视频、51视频、久久视频等主流平台平均每日更新内容超过2000条，我们确保导航信息的及时性和准确性。',
    },
    {
      question: '在手机上访问向日葵视频体验怎么样？',
      answer: '向日葵视频已完成全面的移动端适配优化，无论在手机浏览器还是平板设备上都能获得流畅的浏览体验，页面加载速度快，界面清晰易用。',
    },
    {
      question: '如何快速找到91视频同类型的其他数字视频平台？',
      answer: '您可以通过向日葵视频首页的"专题合集"和"焦点专题"模块，快速发现与91视频同类型的优质数字视频平台，我们已为您分类整理好了各平台的核心特色。',
    },
  ],
};

export const appData = {
  title: '随时随地畅享',
  subtitle: '移动端访问体验全面优化',
  desc: '向日葵视频支持所有主流移动设备访问，无需下载安装即可获得流畅的数字视频平台导航体验。打开手机浏览器，输入网址即可开始探索海量视频资源。',
  features: ['响应式适配', '省流量模式', '手势操作', '夜间模式'],
};

export const rankingData = {
  title: '热门排行',
  items: [
    { rank: 1, name: '91视频热门合集', score: '9.8', change: 'up' },
    { rank: 2, name: '97视频高清全集', score: '9.6', change: 'up' },
    { rank: 3, name: '久久视频精选', score: '9.4', change: 'same' },
    { rank: 4, name: '51视频独家', score: '9.2', change: 'up' },
    { rank: 5, name: '数字视频新片', score: '9.0', change: 'down' },
  ],
};

export const commentsData = {
  title: '用户反馈',
  items: [
    {
      avatar: '匿',
      name: '影迷小王',
      time: '3天前',
      content: '向日葵视频真的太方便了！以前要在好几个平台之间来回切换找资源，现在一个站点就能看到91视频、97视频这些平台的导航，省了好多时间。',
      platform: '来自 91视频专区',
    },
    {
      avatar: '匿',
      name: '电影达人',
      time: '5天前',
      content: '不得不说51视频和久久视频的内容整合做得很好，分类清晰更新快，基本每天都有新内容推荐。作为老用户真心推荐给新朋友。',
      platform: '来自 51视频专区',
    },
    {
      avatar: '匿',
      name: '剧荒患者',
      time: '1周前',
      content: '找91视频同类型的数字视频平台找了好久，终于在这里找到了完整的导航，页面加载也很快，手机上看一点都不卡。',
      platform: '来自 久久视频专区',
    },
    {
      avatar: '匿',
      name: '夜猫子观影',
      time: '1周前',
      content: '97视频的高清全集频道做得特别用心，各种分类一目了然。向日葵视频这个导航站真的是数字视频爱好者的福音。',
      platform: '来自 97视频专区',
    },
    {
      avatar: '匿',
      name: '休闲观众',
      time: '2周前',
      content: '朋友推荐来的，一开始以为是普通的导航站，用了之后才发现内容真的全，51视频、久久视频这些都能找到，界面也很清爽。',
      platform: '来自 综合推荐',
    },
  ],
};

export const cardsData = {
  title: '精选推荐',
  items: [
    {
      title: '91视频本周热播',
      desc: '91视频平台本周最受欢迎内容精选，实时数据更新，帮你跟上热点。',
      imageSeq: 'card-01',
      imageQuery: 'Warm%20minimalist%20abstract%20composition%20with%20golden%20geometric%20shapes%20on%20cream%20background%2C%20soft%20elegant%20lighting%2C%20modern%20lifestyle%20aesthetic%2C%20clean%20simple%20design%2C%20premium%20textured%20finish',
    },
    {
      title: '97视频新上内容',
      desc: '97视频平台最新上线的高清内容一览，每日定时更新不重样。',
      imageSeq: 'card-02',
      imageQuery: 'Sophisticated%20abstract%20layered%20waves%20in%20warm%20amber%20and%20cream%20tones%2C%20minimalist%20modern%20art%2C%20soft%20diffused%20light%2C%20elegant%20composition%2C%20clean%20premium%20aesthetic',
    },
    {
      title: '51视频独家推荐',
      desc: '仅在51视频平台可以找到的独家优质资源，不容错过的好内容。',
      imageSeq: 'card-03',
      imageQuery: 'Modern%20abstract%20circles%20in%20terracotta%20and%20warm%20beige%20hues%2C%20minimalist%20gallery%20style%2C%20soft%20atmospheric%20lighting%2C%20elegant%20refined%20composition%2C%20smooth%20textures',
    },
    {
      title: '久久视频高分合集',
      desc: '久久视频平台用户评分最高的内容整理，品质保证值得一看。',
      imageSeq: 'card-04',
      imageQuery: 'Warm%20abstract%20fluid%20flowing%20shapes%20in%20golden%20honey%20and%20cream%2C%20modern%20luxurious%20design%2C%20soft%20ethereal%20lighting%2C%20elegant%20minimalist%20aesthetic%2C%20premium%20textures',
    },
    {
      title: '数字视频新片速递',
      desc: '各大数字视频平台最新上架内容速览，第一时间了解更新动态。',
      imageSeq: 'card-05',
      imageQuery: 'Contemporary%20abstract%20geometric%20grid%20in%20warm%20amber%20and%20cream%2C%20modern%20clean%20design%2C%20soft%20ambient%20light%2C%20minimalist%20aesthetic%2C%20premium%20elegant%20composition',
    },
    {
      title: '同类型平台推荐',
      desc: '发现更多91视频同类型的优质数字视频平台，拓展你的观影选择。',
      imageSeq: 'card-06',
      imageQuery: 'Elegant%20abstract%20organic%20patterns%20in%20terracotta%20warm%20beige%20and%20cream%2C%20modern%20art%20style%2C%20soft%20diffused%20lighting%2C%20minimalist%20luxurious%20aesthetic%2C%20smooth%20textured%20finish',
    },
  ],
};

export const mediaData = {
  title: '视频精选',
  items: [
    {
      title: '91视频精彩集锦',
      desc: '91视频平台精彩内容概览',
      duration: '15:32',
      imageSeq: 'media-01',
      imageQuery: 'Cinematic%20warm%20golden%20abstract%20composition%20with%20soft%20bokeh%20effect%2C%20film%20reel%20inspired%2C%20luxurious%20amber%20and%20cream%20tones%2C%20professional%20cinematography%20aesthetic%2C%20shallow%20depth%20of%20field',
    },
    {
      title: '97视频高清赏析',
      desc: '97视频高清画质内容展示',
      duration: '22:08',
      imageSeq: 'media-02',
      imageQuery: 'Professional%20warm%20toned%20abstract%20composition%20with%20cinematic%20lighting%2C%20film%20texture%2C%20golden%20hour%20warmth%2C%20elegant%20amber%20and%20cream%20palette%2C%20shallow%20depth%20of%20field%2C%20premium%20look',
    },
    {
      title: '久久视频热门精选',
      desc: '久久视频平台热播内容速览',
      duration: '18:45',
      imageSeq: 'media-03',
      imageQuery: 'Cinematic%20warm%20abstract%20art%20with%20soft%20golden%20light%2C%20film%20grain%20texture%2C%20elegant%20terracotta%20and%20cream%20tones%2C%20professional%20film%20aesthetic%2C%20shallow%20depth%20of%20field',
    },
    {
      title: '51视频独家看点',
      desc: '51视频平台独家内容推介',
      duration: '12:56',
      imageSeq: 'media-04',
      imageQuery: 'Beautiful%20warm%20abstract%20composition%20with%20cinematic%20golden%20lighting%2C%20film%20reel%20aesthetic%2C%20amber%20honey%20and%20cream%20tones%2C%20professional%20cinematography%20style%2C%20shallow%20depth%20of%20field',
    },
  ],
};

export const contactData = {
  title: '联系我们',
  desc: '如有数字视频平台收录建议、合作意向或问题反馈，欢迎通过以下方式联系我们。向日葵视频持续致力于打造更全面的数字视频平台大全。',
  email: 'contact@xiangrikuishipin.com',
  hours: '周一至周五 9:00 - 18:00',
};

export const footerData = {
  about: '向日葵视频是一个综合性的数字视频平台导航站点，覆盖91视频、97视频、51视频、久久视频等主流数字视频平台，致力于为用户提供便捷、安全、全面的在线观看入口导航服务。',
  quickLinks: [
    { label: '专题合集', href: '#index' },
    { label: '视频精选', href: '#media' },
    { label: '平台优势', href: '#features' },
    { label: '焦点专题', href: '#carousel' },
    { label: '关于我们', href: '#about' },
    { label: '常见问题', href: '#faq' },
  ],
};